import * as screens from '@core/layouts/components/menu/screens';
import Icon from '../../utility/icomoon';
import paths from '../../views/screens/Protocols/paths';
import permissions from '../../views/screens/Protocols/permissions';

export default [
  {
    id: 'consoleCatalog',
    title: 'console.consoleCatalog',
    icon: <Icon size={20} icon="List" />,
    permissions: [
      permissions.viewConsoleCatalog,
      permissions.addConsole,
      permissions.editConsole
    ],
    iconName: 'List',
    navLink: paths.consolesList,
    screenId: screens.PROTOCOL_CATALOG
  }
];
